import React, { useState } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import AddLocationModal from './AddLocationModal';
import LocationsResult from './LocationsResult';
import { IntegrationDetailLocations } from './style';
import ExportLocationsModal from './ExportLocationsModal';

export default function IntegrationDetails({
  integration = {},
  setRefresh = noop,
  inSharedSetting = false,
}) {
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleExportModal, setVisibleExportModal] = useState(false);

  return (
    <IntegrationDetailLocations
      textAlign="center"
      name="integrationDetailLocations"
    >
      <LocationsResult
        integrationId={integration?.id}
        setVisibleModal={setVisibleModal}
        setVisibleExportModal={setVisibleExportModal}
        inSharedSetting={inSharedSetting}
      />

      {/* Remounted per integration: the page is reused across :identifier changes,
          and the modal's import polling belongs to the integration it started on. */}
      <AddLocationModal
        key={integration?.id}
        setVisibleModal={setVisibleModal}
        visibleModal={visibleModal}
        integration={integration}
        setRefresh={setRefresh}
      />
      <ExportLocationsModal
        visibleExportModal={visibleExportModal}
        setVisibleExportModal={setVisibleExportModal}
        integration={integration}
      />
    </IntegrationDetailLocations>
  );
}
IntegrationDetails.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  integration: PropTypes.objectOf(PropTypes.any),
  setRefresh: PropTypes.func,
  inSharedSetting: PropTypes.bool,
};
